import { faHashtag } from '@fortawesome/pro-regular-svg-icons/faHashtag'
import { Emoji, Icon } from 'src/components'
import { MenuItemImageProps } from './menuItemImage.types'
import { Wrapper } from './menuItemImage.styles'

const MenuItemImage = ({ community, hasNotification }: MenuItemImageProps) => {
  if (community.icon) {
    return (
      <Wrapper $hasNotification={hasNotification}>
        <Emoji id={community.icon} size="1.5rem" />
      </Wrapper>
    )
  }

  /**
   * TODO: Verificar a possibilidade de crop da imagem no back-end
   */
  if (community.imageURL) {
    return (
      <Wrapper $hasNotification={hasNotification}>
        <img src={community.imageURL} alt={community.name} loading="lazy" />
      </Wrapper>
    )
  }

  return (
    <Wrapper $hasNotification={hasNotification}>
      <Icon icon={faHashtag} className="_text-gray-900" />
    </Wrapper>
  )
}

export default MenuItemImage
